import {
  BookOpen,
  Bell,
  Phone,
  MessageSquare,
  FileText,
  CheckCircle,
  XCircle,
  AlertCircle,
  GraduationCap,
} from 'lucide-react';
import { type NotificationType } from '@teachur/http-client';

export const getNotificationIcon = (type: NotificationType) => {
  switch (type) {
    case 'instructorAcceptedCall':
      return CheckCircle;
    case 'instructorRejectedCall':
      return XCircle;
    case 'instructorCancelledCall':
      return AlertCircle;
    case 'studentProjectAdded':
      return FileText;
    case 'studentProjectFeedback':
      return FileText;
    case 'userChat':
      return MessageSquare;
    case 'studentRequestCourseHearing':
      return Phone;
    case 'studentCourseDiscussions':
      return BookOpen;
    case 'degreeSwitched':
      return GraduationCap;
    default:
      return Bell;
  }
};

export const getNotificationIconColor = (type: NotificationType): string => {
  switch (type) {
    case 'instructorAcceptedCall':
      return 'bg-green-100 text-green-600';
    case 'instructorRejectedCall':
      return 'bg-red-100 text-red-600';
    case 'instructorCancelledCall':
      return 'bg-orange-100 text-orange-600';
    case 'studentProjectAdded':
      return 'bg-blue-100 text-blue-600';
    case 'studentProjectFeedback':
      return 'bg-purple-100 text-purple-600';
    case 'userChat':
      return 'bg-cyan-100 text-cyan-600';
    case 'studentRequestCourseHearing':
      return 'bg-indigo-100 text-indigo-600';
    case 'studentCourseDiscussions':
      return 'bg-teal-100 text-teal-600';
    case 'degreeSwitched':
      return 'bg-amber-100 text-amber-600';
    default:
      return 'bg-gray-100 text-gray-600';
  }
};

export const formatNotificationTime = (timestamp: string): string => {
  const normalized = /[Z+\-]\d*$/.test(timestamp) ? timestamp : `${timestamp}Z`;
  const date = new Date(normalized);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins} min${diffMins > 1 ? 's' : ''} ago`;
  if (diffHours < 24) return `${diffHours} hr${diffHours > 1 ? 's' : ''} ago`;
  if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;

  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};
